import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=b64d31d2&scoped=true&"
import script from "./periodical.vue?vue&type=script&lang=js&"
export * from "./periodical.vue?vue&type=script&lang=js&"
import style0 from "./periodical.vue?vue&type=style&index=0&lang=less&"
import style1 from "./periodical.vue?vue&type=style&index=1&id=b64d31d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64d31d2",
  null
  
)

component.options.__file = "periodical.vue"
export default component.exports